import { AppRecord, AppRecordStatus } from "models/appRecord";
import printJS from "print-js";
import { useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { AppLog } from "services";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";

const ProductAction = () => {
  // ==============state===========
  const { token } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const [searchTextInput, setSearchTextInput] = useState<string>("");
  const [openPopoverIndex, setOpenPopoverIndex] = useState<number | null>(null);
  const [defaultDataProduct, setDefaultDataProduct] = useState<boolean>(false);
  //   ==========state fetch init ========
  const [loadingFetchDataProducts, setLoadingFetchDataProducts] = useState<boolean>(false);
  const [selectedProductGroupCodeId, setSelectedProductGroupCodeId] = useState<any>(null);
  const { btnToggleProduct } = useAppSelector((state) => state.header);
  const [dob, setDob] = useState(new Date().toISOString().split("T")[0]); // "2025-05-05"
  const [productDatas, setProductDatas] = useState<any>(null);
  const [productLoading, setProductLoading] = useState<any>(null);
  const [loadingFetchDataProductDetail, setLoadingFetchDataProductDetail] = useState<boolean>(false);
  const [editItemShopProduct, setEditItemShopProduct] = useState<any>({});
  //   delete
  const [selectedProductIds, setSelectedProductIds] = useState<string[]>([]);
  const [selectProducts, setSelectProducts] = useState<boolean>(false);

  const initUserShopProduct = async () => {
    setLoadingFetchDataProducts(true);
    try {
      const url = `${RouteApi.getProductSearch}token=${token}`;
      const data = {
        shop_id: shopId,
        search_text: searchTextInput,
        product_group_id: selectedProductGroupCodeId,
        is_deleted: btnToggleProduct ? 1 : 0,
        working_date: dob,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingFetchDataProducts(false);
        const stateRecord: AppRecord = {
          currentPage: 1,
          currentIndex: 0,
          nextPageUrl: response["user_shop_products"]["next_page_url"] ?? "",
          totalRecord: 0,
          loadingStatus: response["user_shop_products"]["next_page_url"] != null ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
        };
        setProductDatas(response["user_shop_products"]);
        setProductLoading(stateRecord);
      }
    } catch (error) {
      setLoadingFetchDataProducts(false);

      AppLog.show({
        message: `[initUserShopProduct]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const loadingProductState = {
    currentPage: 1,
    currentIndex: 0,
    nextPageUrl: "",
    totalRecord: 0,
    loadingStatus: AppRecordStatus.loading,
  };
  const fetchMoreUserShopProduct = async ({ next }: { next: string }) => {
    if (!next) return;
    setProductLoading({
      ...loadingProductState,
      loadingStatus: AppRecordStatus.loadingMore,
    });

    try {
      const responses = await RequestApi(next);

      if (responses.status === "success") {
        const newEmployees = responses["user_shop_products"]["data"];
        const nextPage = responses["user_shop_products"]["next_page_url"];

        const updatedData = [...(productDatas?.data || []), ...newEmployees];

        setProductDatas({
          ...responses["user_shop_products"],
          data: updatedData,
        });

        setProductLoading({
          ...loadingProductState,
          nextPageUrl: nextPage ?? "",
          loadingStatus: nextPage ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
        });
      }
    } catch (error) {
      console.error("Failed to fetch more employees:", error);
    }
  };
  const getShopProductDetail = async (product_id: any, product_group_id: any) => {
    setLoadingFetchDataProductDetail(true);
    try {
      const url = `${RouteApi.getshopproductdetail}token=${token}`;
      const data = {
        shop_id: shopId,
        product_id: product_id, // Use product_id
        product_group_id: product_group_id,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingFetchDataProductDetail(false);
        setEditItemShopProduct(response.user_shop_product);
      }
    } catch (error) {
      setLoadingFetchDataProductDetail(false);

      AppLog.show({
        message: `[getShopProductDetail]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const onSubmitDeleteProdcuts = async () => {
    try {
      let url: string = "";
      url = RouteApi.submitDeleteShopProducts;
      url += `token=${token}`;
      const data = {
        shop_id: shopId,
        product_ids: selectedProductIds,
        product_group_id: selectedProductGroupCodeId,
        permanence_deleted: btnToggleProduct ? 2 : 0,
      };
      await RequestApi(url, { data })
        .then((responses) => {
          if (responses) {
            setProductDatas((prevItemGroups: any) => {
              return {
                ...prevItemGroups,
                data: (prevItemGroups.data || []).filter((item: any) => !selectedProductIds.includes(item.id)),
              };
            });
            setSelectProducts(false);
            setSelectedProductIds([]);
          } else {
          }
        })
        .catch((err) => {
          console.log(err);
        });
      // setLoadingSubmit(false);
    } catch (error) {
      AppLog.show({
        message: `[onSubmitDeleteProdcuts]`,
        status: StatusMsg.error,
        error,
      });
      // setLoadingSubmit(false);
    }
  };
  const submitUndoDeleteShopProduct = async () => {
    try {
      let url: string = "";
      url = RouteApi.submitUndoDeleteShopProduct;
      url += `token=${token}`;
      const data = {
        shop_id: shopId,
        product_ids: selectedProductIds,
        product_group_id: selectedProductGroupCodeId,
      };
      await RequestApi(url, { data })
        .then((responses) => {
          if (responses) {
            setProductDatas((prevItemGroups: any) => {
              return {
                ...prevItemGroups,
                data: (prevItemGroups.data || []).filter((item: any) => !selectedProductIds.includes(item.id)),
              };
            });
            setSelectProducts(false);
            setSelectedProductIds([]);
          } else {
          }
        })
        .catch((err) => {
          console.log(err);
        });
      // setLoadingSubmit(false);
    } catch (error) {
      AppLog.show({
        message: `[submitUndoDeleteShopProduct]`,
        status: StatusMsg.error,
        error,
      });
      // setLoadingSubmit(false); (myData.data || []).filter(item)=>myId.includes(item.id)
    }
  };
  //   ==========state fetch category ========
  const [loadingFetchDataCategoires, setLoadingFetchDataCategoires] = useState<boolean>(false);
  const seeMoreCategoriesGroupLoadingState = useRef<any>(null);
  const [itemGroups, setItemGroups] = useState<any>();
  const [itemPrinter, setItemPrinter] = useState<any>(null);
  const [storage_host_cluster_Id, setStorage_host_cluster_Id] = useState<any>();
  const loadingProductCategoriesState = {
    currentPage: 1,
    currentIndex: 0,
    nextPageUrl: "",
    totalRecord: 0,
    loadingStatus: AppRecordStatus.loading,
  };
  const [errorStatus, setErrorStatus] = useState({
    title: "",
    message: "",
  });
  const [warning, setWarning] = useState(false);
  const initCategories = async () => {
    setLoadingFetchDataCategoires(true);
    try {
      const url = `${RouteApi.getShopProductGroup}token=${token}`;
      const data = {
        shop_id: shopId,
        search_text: searchTextInput,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingFetchDataCategoires(false);
        const stateRecord: AppRecord = {
          currentPage: 1,
          currentIndex: 0,
          nextPageUrl: response["user_product_groups"]["next_page_url"] ?? "",
          totalRecord: 0,
          loadingStatus: response["user_product_groups"]["next_page_url"] != null ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
        };
        // setCategoriesLoading(stateRecord);
        seeMoreCategoriesGroupLoadingState.current = stateRecord;
        setItemGroups(response["user_product_groups"]);
        setItemPrinter(response["user_shop_printers"]);
        setStorage_host_cluster_Id(response.storage_host_cluster);
      } else {
        setLoadingFetchDataCategoires(false);

        setErrorStatus({
          title: response.status,
          message: response.msg,
        });
        setWarning(true);
      }
    } catch (error) {
      setLoadingFetchDataCategoires(false);

      AppLog.show({
        message: `[initCategories]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const fetchMoreCategories = async ({ next }: { next: string }) => {
    if (next === "") return;
    seeMoreCategoriesGroupLoadingState.current = {
      ...loadingProductCategoriesState,
      loadingStatus: AppRecordStatus.loadingMore,
    };

    await RequestApi(next).then((responses) => {
      if (responses.status === "success") {
        const stateRecord: AppRecord = {
          currentPage: 1,
          currentIndex: 0,
          nextPageUrl: responses["user_product_groups"]["next_page_url"] ?? "",
          totalRecord: 0,
          loadingStatus: responses["user_product_groups"]["next_page_url"] !== null ? AppRecordStatus.noLoadMore : AppRecordStatus.loaded,
        };
        setItemGroups((prev: any) => ({
          ...prev,
          data: [...prev.data, ...responses.user_product_groups.data],
        }));
        seeMoreCategoriesGroupLoadingState.current = stateRecord;
      } else {
        setErrorStatus({
          title: responses.status,
          message: responses.msg,
        });
        setWarning(true);
      }
    });
  };
  const containerRef = useRef<HTMLDivElement>(null);

  const handleScroll = () => {
    const container = containerRef.current;
    if (!container) return;

    const scrollLeft = container.scrollLeft;
    const scrollWidth = container.scrollWidth;
    const clientWidth = container.clientWidth;

    const nearEndThreshold = 300;
    const atNearEnd = scrollWidth - scrollLeft - clientWidth <= nearEndThreshold;

    if (atNearEnd) {
      fetchMoreCategories({
        next: seeMoreCategoriesGroupLoadingState.current.nextPageUrl,
      });
    }
  };
  // print
  const [loadingPrint, setLoadingPrint] = useState<boolean>(false);
  const handlePrint = async () => {
    setLoadingPrint(true);
    try {
      const url = `${storage_host_cluster_Id.host_name}/api-mobile-flipflop/v1/get-shop-product-report?token=${token}`;
      const data = {
        shop_id: shopId,
        search_text: searchTextInput,
        product_group_id: selectedProductGroupCodeId,
        is_deleted: btnToggleProduct ? 1 : 0,
        working_date: dob,
        storage_host_cluster_id: storage_host_cluster_Id.id,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingPrint(false);
        const pdfUrl = response?.pdf_url;
        const pdfResponse = await fetch(pdfUrl);
        const blob = await pdfResponse.blob();
        const blobUrl = URL.createObjectURL(blob);
        printJS({ printable: blobUrl, type: "pdf" });
      } else {
        setLoadingPrint(false);

        console.log(response, "error fetch shop employee");
      }
    } catch (error) {
      setLoadingPrint(false);

      AppLog.show({
        message: `[handlePrint]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const [id, setId] = useState<number>(itemGroups?.data?.length ? itemGroups.data[0].product_group_id : null);
  const [selectedProductGroupCode, setSelectedProductGroupCode] = useState<string>("All");

  const selectedProductGroupCodeRef = useRef(selectedProductGroupCode);
  const handleClickCategory = ({ categoryName, groupId }: { categoryName: string; groupId: string }) => {
    if (selectedProductGroupCode === categoryName) return;
    setSelectedProductGroupCode(categoryName);
    setSelectedProductGroupCodeId(groupId);
    selectedProductGroupCodeRef.current = categoryName;
  };
  return {
    // state init
    initUserShopProduct,
    loadingFetchDataProducts,
    setSearchTextInput,
    searchTextInput,
    setSelectedProductGroupCodeId,
    selectedProductGroupCodeId,
    productDatas,
    setProductDatas,
    productLoading,
    setProductLoading,
    fetchMoreUserShopProduct,
    // detail
    getShopProductDetail,
    loadingFetchDataProductDetail,
    setLoadingFetchDataProductDetail,
    editItemShopProduct,
    setEditItemShopProduct,
    // delete
    onSubmitDeleteProdcuts,
    selectedProductIds,
    setSelectedProductIds,
    selectProducts,
    setSelectProducts,
    // undo delete
    submitUndoDeleteShopProduct,

    // state init category
    initCategories,
    loadingFetchDataCategoires,
    setLoadingFetchDataCategoires,
    seeMoreCategoriesGroupLoadingState,
    itemGroups,
    setItemGroups,
    itemPrinter,
    setItemPrinter,
    storage_host_cluster_Id,
    fetchMoreCategories,
    handleScroll,

    // print
    loadingPrint,
    setLoadingPrint,
    handlePrint,

    openPopoverIndex,
    setOpenPopoverIndex,
    defaultDataProduct,
    setDefaultDataProduct,
    id,
    setId,
    // ----------
    handleClickCategory,
    selectedProductGroupCode,
    setSelectedProductGroupCode,
    errorStatus,
    setErrorStatus,
    warning,
  };
};
export default ProductAction;
